module.exports = __webpack_public_path__ + "img/people.efc0baf2.svg";